import { getGPUTier } from 'detect-gpu';

window.moderatedDetectGPU = async function () {
    return await getGPUTier();
}